// The Approved feed deliveries table's column-visibility toggle. Its optional columns are Feed
// category and Created by, both always offered and defaulting off. Pure, no Vue dependency - same shape as
// `pigsStatusRecords/useStatusColumnVisibility.ts`. The generic mechanics (storage, toggling,
// select-all) live in the shared `useColumnVisibilityOverrides` composable instead. Price, Protein and
// Phosphorus keep their own existing show/hide rules and are not part of this toggle.

/** The columns a reader can show or hide. Other columns are not part of this toggle. */
export type FeedDeliveriesToggleColumnId = 'feed_category' | 'created_by';

/** Left-to-right table order of the mutable columns. */
export const TOGGLE_COLUMN_IDS: readonly FeedDeliveriesToggleColumnId[] = ['feed_category', 'created_by'];
